import { render, staticRenderFns } from "./orderReportBase.vue?vue&type=template&id=0062b74c&scoped=true"
import script from "./orderReportBase.vue?vue&type=script&lang=js"
export * from "./orderReportBase.vue?vue&type=script&lang=js"
import style0 from "./orderReportBase.vue?vue&type=style&index=0&id=0062b74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062b74c",
  null
  
)

export default component.exports